import React from 'react';
import { Link } from 'react-router-dom';

import info from '../info.json';
import { POSTS } from '../posts';

const formatDate = (iso: string): string => {
    if (!iso) return '';
    try {
        return new Date(iso).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    } catch {
        return iso;
    }
};

const BlogIndex: React.FC = () => (
    <main className="max-w-3xl mx-auto px-6 sm:px-10 lg:px-12 py-16 sm:py-24">
        <header className="flex items-baseline justify-between mb-16">
            <Link
                to="/"
                className="font-display text-2xl text-ink-900 dark:text-ink-50 tracking-tight no-underline hover:text-accent dark:hover:text-accent-soft transition-colors"
            >
                {info.PROFILE_NAME}
            </Link>
            <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-accent dark:text-accent-soft">
                Journal
            </span>
        </header>

        {POSTS.length === 0 ? (
            <p className="text-ink-500 dark:text-ink-400 italic">No posts yet.</p>
        ) : (
            <div className="border-t border-ink-200 dark:border-ink-700">
                {POSTS.map((post) => (
                    <article
                        key={post.slug}
                        className="group py-8 border-b border-ink-200 dark:border-ink-700"
                    >
                        <div className="flex items-baseline justify-between gap-6 mb-2">
                            <Link
                                to={post.href ?? `/journal/${post.slug}`}
                                reloadDocument={!!post.href}
                                className="font-display text-2xl sm:text-3xl text-ink-900 dark:text-ink-50 tracking-tight no-underline group-hover:text-accent dark:group-hover:text-accent-soft transition-colors"
                            >
                                {post.title}
                            </Link>
                            <div className="shrink-0 text-right">
                                <time
                                    className="block font-mono text-[11px] uppercase tracking-wider text-ink-400 dark:text-ink-500"
                                    dateTime={post.date}
                                >
                                    {formatDate(post.date)}
                                </time>
                                {post.href && (
                                    <span className="block mt-1 font-mono text-[11px] uppercase tracking-wider text-accent dark:text-accent-soft">
                                        Interactive
                                    </span>
                                )}
                            </div>
                        </div>
                        {post.summary && (
                            <p className="text-ink-700 dark:text-ink-200 text-[15px] leading-relaxed">
                                {post.summary}
                            </p>
                        )}
                    </article>
                ))}
            </div>
        )}
    </main>
);

export default BlogIndex;
